// extracted by mini-css-extract-plugin
export default {"container":"MainPainItem_container__RbdZA","remove":"MainPainItem_remove__uuqM6"};